import { Avatar, HStack, Stack, Text } from '@chakra-ui/react';

import { IGetBillers } from '../../../../store/slices/billsPayment/getBillersCategorySlice';
import { IBillBeneficiary } from '../../../../types/beneficiary';

interface BeneficiaryCardInfoProps {
  beneficiary: IBillBeneficiary;
  billCategoriesData:
    | [
        {
          id?: string;
          name?: string;
          description?: string;
          isActive?: boolean;
          billers?: IGetBillers[];
        }
      ]
    | null
    | undefined;
}

export default function BeneficiaryCardInfo({
  beneficiary,
  billCategoriesData,
}: BeneficiaryCardInfoProps) {
  const billerNameToImageUrl: Record<string, string> = {};

  billCategoriesData?.forEach((category) => {
    if (category.billers) {
      category.billers.forEach((biller) => {
        billerNameToImageUrl[biller.name?.toLowerCase() || ''] =
          biller.imageUrl || '';
      });
    }
  });

  return (
    <HStack spacing={3} align="flex-start">
      <Avatar
        name={beneficiary.billAlias}
        boxSize="44px"
        bg="#EBF8FF"
        textColor="#116791"
        fontSize="1.5rem"
        flexShrink={0}
        src={billerNameToImageUrl[beneficiary.billerName?.toLowerCase() || '']}
      />
      <Stack spacing={1} flex={1} minW={0}>
        <Text fontSize=".875rem" noOfLines={1}>
          {beneficiary.billAlias}
        </Text>
        <Text
          color="gray.300"
          fontSize=".75rem"
          lineHeight="171%"
          noOfLines={1}
        >
          {beneficiary.billerName}
        </Text>
        <Text
          color="gray.300"
          fontSize=".75rem"
          lineHeight="171%"
          noOfLines={1}
        >
          {beneficiary.customerId}
        </Text>
      </Stack>
    </HStack>
  );
}
